import "./LoadingCurtain.css";
import { Spin } from "antd";

interface LoadingCurtainProps {}

const LoadingCurtain: React.FC<LoadingCurtainProps> = (_) => {
  return (
    <div className="loading-curtain">
      <Spin />
    </div>
  );
};

export default LoadingCurtain;
